import { AZIONI, kindOf } from './WorkflowBuilder';

// L'elenco delle regole dice a colpo d'occhio cosa fa ognuna, se è accesa e
// quando è partita l'ultima volta (30/09/2026): prima c'erano solo il nome e
// «Messaggi ricevuti», e per sapere se «Mamma» funzionava bisognava aprirla.

const GIORNO = 24 * 3600 * 1000;

// «@spesa · Lista della spesa», «Alle 07:30 · Meteo», «Messaggi ricevuti · Conversazione AI».
export function descrizioneBreve(flow, catalogo = {}) {
  const kind = kindOf(flow);
  const contesti = flow.trigger?.kinds || [kind];
  const parole = flow.trigger?.keywords || [];
  const quando = kind === 'schedule' ? `Alle ${flow.trigger?.schedule?.time || '09:00'}`
    : kind === 'manual' && !contesti.some(c => ['self', 'mine', 'incoming'].includes(c)) ? 'Dal sito'
      : flow.prefix ? flow.prefix
        : flow.trigger?.match === 'anywhere' && parole.length ? `Messaggi con «${parole[0]}»${parole.length > 1 ? '…' : ''}`
          : 'Messaggi ricevuti';
  const azione = flow.steps?.[0]?.action;
  const cosa = AZIONI.find(a => a.id === azione)?.titolo || catalogo[azione]?.label || '';
  return [quando, cosa].filter(Boolean).join(' · ');
}

const STATI = {
  succeeded: { segno: '✓', parola: 'riuscita' }, waiting: { segno: '✓', parola: 'in consegna' },
  failed: { segno: '⚠', parola: 'non riuscita' }, pending: { segno: '…', parola: 'in corso' },
  cancelled: { segno: '–', parola: 'annullata' },
};

// «Ultima: oggi 08:54 ✓ riuscita». Il segno non basta da solo: c'è anche la parola.
export function ultimaEsecuzione(ultima, adesso = new Date()) {
  if (!ultima) return 'Mai partita';
  const quando = new Date(ultima.at);
  const ora = quando.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  const inizio = d => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const giorni = Math.round((inizio(adesso) - inizio(quando)) / GIORNO);
  const giorno = giorni === 0 ? 'oggi' : giorni === 1 ? 'ieri'
    : quando.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
  const stato = STATI[ultima.stato] || { segno: '', parola: ultima.stato };
  return `Ultima: ${giorno} ${ora} ${stato.segno} ${stato.parola}`.replace(/\s+/g, ' ').trim();
}

// Acceso e spento senza aprire la regola. Area di tocco da 44 px, come il
// resto dei comandi sul telefono.
function Interruttore({ acceso, nome, disabilitato, perche, onCambia }) {
  return <button type="button" role="switch" aria-checked={acceso} aria-label={`Regola attiva: ${nome}`}
    title={disabilitato ? perche : undefined} disabled={disabilitato} onClick={() => onCambia(!acceso)}
    className="flex h-11 w-14 shrink-0 items-center justify-center disabled:opacity-50">
    <span className={`relative h-6 w-11 rounded-full transition-colors ${acceso ? 'bg-brand-600' : 'bg-line'}`} aria-hidden>
      <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-surface shadow transition-all ${acceso ? 'left-[22px]' : 'left-0.5'}`} />
    </span>
  </button>;
}

export default function ElencoRegole({ flows, selezionata, catalogo, abilitate, occupato, onApri, onAccendi }) {
  return <ul className="space-y-2">
    {flows.map(flow => {
      // «Dal sito» non parte da sola: non c'è niente da accendere.
      const accendibile = kindOf(flow) !== 'manual' || (flow.trigger?.kinds || []).some(c => ['self', 'mine', 'incoming'].includes(c));
      const senzaAccount = !flow.enabled && !abilitate.includes(flow.connection);
      return <li key={flow.id} className={`flex items-center gap-1 rounded-lg border pl-3 ${selezionata === flow.id ? 'bg-brand-50' : 'bg-surface'}`}>
        <button type="button" disabled={occupato} onClick={() => onApri(flow)} className="min-w-0 flex-1 py-3 text-left">
          <strong className="block break-words">{flow.name}</strong>
          <span className="block break-words text-xs text-muted">{descrizioneBreve(flow, catalogo)}</span>
          <span className="block text-xs text-muted">{ultimaEsecuzione(flow.ultima_esecuzione)}</span>
        </button>
        {accendibile && <Interruttore acceso={flow.enabled} nome={flow.name} disabilitato={occupato || senzaAccount}
          perche="Serve un account WhatsApp abilitato alle automazioni." onCambia={acceso => onAccendi(flow, acceso)} />}
      </li>;
    })}
  </ul>;
}
